import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { MouseButtons, MouseInput } from '../../../platform/input/MouseInput';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ToolBehavior } from '../../canvas/tooling/ToolBehavior';
import { resolve } from '../../Container';
import { Votable } from './Votable';
import { castVote, revokeVote } from './VotingCommands';

class VotingToolBehavior extends ToolBehavior {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;

    private limiter = {} as Record<string, boolean>;

    public getPreferredCursor(state: string) {
        if (state === 'idle' || state === 'voting') {
            return 'crosshair';
        }
    }

    public onMouseDown(state: string, mi: MouseInput): string | void {
        const { dispatch, limiter, } = this;

        if (state !== 'idle' || (mi.button !== MouseButtons.Main && mi.button !== MouseButtons.Secondary)) {
            return;
        }

        const subject = mi.targetPhysical;
        if (!subject) return;
        if (!subject.is(Votable)) return;
        if (limiter[subject.id]) return;

        const command = mi.button === MouseButtons.Main ? castVote : revokeVote;
        dispatch(command, [[subject.id]]);

        return 'voting';
    }

    public onMouseUp(state: string, _mi: MouseInput): string | void {
        if (state === 'voting') {
            return 'idle';
        }
    }
}

export const votingTool = defineToolWithCommonBehaviors({
    id: 'votingTool',
    label: 'Voting',
    category: 'collaboration',
    icon: 'deqo://icons/deqo/voting',
    weight: 1050,
    shortcut: 'B',
    behaviors: [
        VotingToolBehavior,
    ]
});
